import CONSTANT from '../config/constant'
import Utility from '../utility/Utility'
import LIB from '../utility/Library'

export default class Mv {
  constructor() {
    this.main()
  }

  main() {
    document.getElementById('mv-title-left').classList.add(CONSTANT.CLASSNAME.ACTIVE)
    document.getElementById('mv-title-right').classList.add(CONSTANT.CLASSNAME.ACTIVE)
    setTimeout(() => {
      document.getElementById('mv-illust').classList.add(CONSTANT.CLASSNAME.ACTIVE)
    }, 2400)
  }
}


// WEBPACK FOOTER //
// ./src/assets/js/index/Mv.js